export default "__VITE_ASSET__Dz8b6V9D__"